// Dev mode is on when the url has ?dev=1 or ?dev=true (the same check that turns Sentry off in index.html).
// Used, for example, for debug logging that would be too slow to do always.
const DEV_MODE = RegExp('dev=(1|true)').test(window.location.search);

export { DEV_MODE };
